import { useEffect } from 'react';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';

const Page = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace(paths.tms.index);
  }, [router]);

  return null; // or <></> if you prefer
};

export default Page;
